import React, { FC, HTMLAttributes, ReactNode } from 'react';
import './style.scss';

interface CtaProps extends HTMLAttributes<HTMLDivElement> {
  ctaSize: string; //small, medium, and large
  ctaType: string; //active-cta, primary-cta, secondary-cta
  iconClass?: string;
  ctaText: string;
  customClass?: string;
  isIconPositionRight?: boolean;
  isDisabled?: boolean;
  onCtaClick: any;
  icon?: ReactNode;
}

const CtaComponent: FC<CtaProps> = (props) => {
  function renderImagetag() {
    return (
      <div
        className={`${props.isIconPositionRight ? 'tw-ml-[8px]' : 'tw-mr-[8px]'}`}>
        {props.icon}
      </div>
    );
  }

  return (
    <button
      className={`custom-cta-main-container tw-flex tw-justify-center tw-items-center
        ${props.isDisabled ? 'tw-pointer-events-none tw-bg-[#6B6B6B] tw-border-[#6B6B6B]' : ''}
        ${props.customClass || ''} ${props.ctaSize} ${props.ctaType}`}
      onClick={(e: any) => {
        e.stopPropagation();
        props.onCtaClick();
      }}>
      {/* Old code */}
      {/* {props.iconClass && !props.isIconPositionRight ? renderImagetag() : null}
      {props.ctaText}
      {props.iconClass && props.isIconPositionRight ? renderImagetag() : null} */}

      {props?.icon && !props.isIconPositionRight ? renderImagetag() : null}
      {props.ctaText}
      {props?.icon && props.isIconPositionRight ? renderImagetag() : null}
    </button>
  );
};

export default CtaComponent;
